import { MarkedTypeEnum } from '@doltech/utils/lib/constants';
import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';
import { isNil } from 'lodash';
import * as React from 'react';
import { RenderElementProps } from 'slate-react';
import styled from 'styled-components';

import { colorsV2 } from '../../../colors-v2';
import { EditableBlankVoidElementProps } from './components/EditableBlankVoidElement';
import { EDITABLE_BLANK_VOID, EditableVoidPluginOptions } from './types';

const EditableBlankVoidElement = dynamicEditorComponent<EditableBlankVoidElementProps>(() =>
  import('./components/EditableBlankVoidElement').then((mod) => mod.EditableBlankVoidElement)
);

const StyledParagraph = styled.div`
  flex-wrap: wrap;
  align-items: center;
  font-size: 14px;
  line-height: 28px;
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
  span[data-slate-node] {
    font-size: 14px;
    color: ${colorsV2.black100};
    font-weight: 400;
    word-break: break-word;
  }
`;

export const renderElementEditableBlankVoid =
  (options: EditableVoidPluginOptions) =>
  ({ children, attributes, element }: RenderElementProps) => {
    const {
      blanks,
      questionNo,
      readOnly,
      mode,
      userAnswers,
      selectBlankIndex,
      withDot,
      noArrow,
      showBlankBackground,
      withQuestionNoOutsideBlankBlock,
      onUserAnswerChange,
      onClickBlank,
    } = options;
    if (element.type === EDITABLE_BLANK_VOID) {
      const blankId = element?.children?.[0]?.blankId || element?.blankId || element?.id;
      const blank = blanks.find((b) => b.blankId === blankId);
      const findUserAnswer = userAnswers?.find((ua) => ua.blankId === blankId) || {
        userAnswer: '',
        markedStatus: MarkedTypeEnum.MISSING,
      };
      const { correctAnswer, userAnswer, markedStatus } = findUserAnswer;
      return (
        <EditableBlankVoidElement
          element={element}
          attributes={attributes}
          blank={blank}
          questionNo={questionNo}
          readOnly={readOnly}
          mode={mode}
          text={userAnswer}
          correctText={correctAnswer}
          markedStatus={markedStatus}
          selectBlankIndex={selectBlankIndex}
          withDot={withDot}
          noArrow={noArrow}
          showBlankBackground={showBlankBackground}
          withQuestionNoOutsideBlankBlock={withQuestionNoOutsideBlankBlock}
          onUserAnswerChange={onUserAnswerChange}
          onClickBlank={onClickBlank}
        >
          {children}
        </EditableBlankVoidElement>
      );
    }
    const blankIndex = blanks.find(
      (b) =>
        b.blankId ===
        element.children?.find((c) => c.type === 'editable-blank-void')?.children[0]?.blankId
    )?.blankIndex;
    if (!isNil(blankIndex)) {
      return (
        <StyledParagraph
          className="paragraph-blank"
          {...attributes}
          id={`question-no-${questionNo + blankIndex}`}
        >
          {children}
        </StyledParagraph>
      );
    }
    return null;
  };
